import { Classes, Intent } from "@blueprintjs/core";
import { Tone } from "./shared";

const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function randomAlpha(length: number): string {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);

  let value = "";
  for (let i = 0; i < length; i++) {
    value += letters[bytes[i] % letters.length];
  }
  return value;
}

export function toneClass(tone: Tone): string {
  switch (tone) {
    case Tone.NONE:
      return "";
    case Tone.PRIMARY:
      return Classes.INTENT_PRIMARY;
    case Tone.ASSIST:
      return "bp6-intent-assist";
    case Tone.SUCCESS:
      return Classes.INTENT_SUCCESS;
    case Tone.WARNING:
      return Classes.INTENT_WARNING;
    case Tone.DANGER:
      return Classes.INTENT_DANGER;
  }
}

export function toneToIntent(tone: Tone): Intent | undefined {
  switch (tone) {
    case Tone.NONE:
      return Intent.NONE;
    case Tone.PRIMARY:
      return Intent.PRIMARY;
    case Tone.SUCCESS:
      return Intent.SUCCESS;
    case Tone.WARNING:
      return Intent.WARNING;
    case Tone.DANGER:
      return Intent.DANGER;
    default:
      return undefined;
  }
}
